import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { openModalAdvice } from '../../utils/modals';

const Notifications = ({ config, onAnalize, onAccept }) => {
  useEffect(() => {
    const timeouts = [];

    if (!window?.IS_RUNNING_IN_CYPRESS) {
      for (const item of config) {
        if (onAnalize(item)) {
          const { title, children, hasButtons, icon } = item;

          const timeout = setTimeout(() => {
            openModalAdvice({
              title,
              children,
              hasButtons,
              icon,
              ...(hasButtons
                ? {
                    accept: () => onAccept(item),
                    close: () => {},
                  }
                : {
                    close: () => onAccept(item),
                  }),
            });
          }, 100);

          timeouts.push(timeout);
        }
      }
    }

    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [onAnalize]);
};

export default Notifications;

Notifications.propTypes = {
  config: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.title,
      children: PropTypes.element,
      customButtons: PropTypes.bool,
    }),
  ).isRequired,
  onAnalize: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
};
